import { GraphQLEnumType } from 'graphql';

module.exports = new GraphQLEnumType({
  name: 'cardCompletionTypeEnum',
  values: {
    TIME_BASED: {
      value: 'TIME_BASED'
    },
    SCROLL_BASED: {
      value: 'SCROLL_BASED'
    },
    OPTIONAL: {
      value: 'OPTIONAL'
    },
    COMPLETION_FROM_CONTENT: {
      value: 'COMPLETION_FROM_CONTENT'
    }
  }
});
